import { HttpClient } from '@angular/common/http';
import { Injectable, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Listlang, listresponse } from 'src/interface/lang';
import { EnvService } from './env.service';

@Injectable({
    providedIn: 'root'
})
export class LanguagesService {
    @Output() loaderStatus: Subject<Listlang[]> = new Subject;
    loaderSubject = this.loaderStatus.asObservable();

    constructor(private http: HttpClient, private envService: EnvService) { }

    getActiveLang(): Observable<listresponse> {
        return this.http.get<listresponse>(this.envService.siteApiUrl + "web/getAllLanguages");
    }

}
